import { http, HttpResponse } from 'msw';

import { finish } from './fixture/finish';
import { status } from './fixture/status';
import { feedback } from './fixture/feedback';

export const finishHandlers = [
  http.post('**/:signatureRequestKey/finish', () => HttpResponse.json(finish)),
  http.get('**/:signatureRequestKey/feedback', () => HttpResponse.json(feedback)),
  http.get('**/:signatureRequestKey/status', () => HttpResponse.json(status)),
];
